import * as api from 'dragonmouse-shared/api/forge';
import forge from 'apis/forge';
import { IconType } from 'components/Icon';
import ActionButton from 'components/Widget/ActionButton';
import { ChatMode, ChatStatus } from 'dragonmouse-shared/interfaces';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectActiveDsChat } from 'redux/db/reducers';
import { RootReducer } from 'redux/reducers';

interface Props {
	label: string;
	prompt: string;
}

const GenerateGalleryAction = ({ label, prompt }: Props) => {
	const [isLoading, setIsLoading] = useState(false);
	const dsChat = useSelector((r: RootReducer) => selectActiveDsChat(r.db));

	const onClick = async () => {
		if (!dsChat || isLoading) return;
		setIsLoading(true);
		try {
			await forge.updateDsChat({
				update: {
					id: dsChat.id,
					metadata: { status: ChatStatus.PROCESSING, statusMessage: '' },
				},
			});
			const entry: api.AddUserEntryDsChatRequest['entry'] = {
				kind: 'user',
				message: prompt,
				attachments: [],
				sourceFrameIds: [],
			};
			await forge.dsChatAddUserEntry.withToast()({
				dsChatId: dsChat.id,
				entry,
				chatMode: ChatMode.DESIGN_AND_CHAT,
			});
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<ActionButton
			icon={IconType.LAYOUT}
			label={label}
			loadingLabel="Generating gallery page..."
			isLoading={isLoading}
			prompt={prompt}
			onClick={onClick}
		/>
	);
};

export default GenerateGalleryAction;
